import {useState} from 'react'
import type React from 'react'
import type {SyntheticEvent} from 'react'
import {useParams} from 'react-router-dom'

import {getValidationErrorMessage} from '../../../../../../../utils/validators'
import usePipelineSecretErrorMessages from '../hooks/usePipelineSecretErrorMessages'

import {errorMessageNotEmptyField, validators} from './PipelineSecretForm.consts'

import {restApi} from 'src/services/rest'

function usePipelineSecretForm(
  isEditMode: boolean,
  name: string,
  onConfirm: (name: string, token: string) => void,
) {
  const {id = ''} = useParams()
  const [secretNameErrorMessage, setSecretNameErrorMessage] = useState<string | null>(null)
  const [secretValueErrorMessage, setSecretValueErrorMessage] = useState<string | null>(null)
  const [addSecureToken, {isLoading: isAddSecureTokenLoading}] =
    restApi.endpoints.addSecureToken.useMutation()
  const [secretName, setSecretName] = useState<string>(name)
  const [secretValue, setSecretValue] = useState<string>('')
  const {compareValidatorArray} = usePipelineSecretErrorMessages(secretName)
  const handlerSecretNameInputChange = ({target}: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = target
    const {message} = getValidationErrorMessage({
      value,
      validators,
      compareArray: compareValidatorArray,
    })

    if (message) {
      setSecretNameErrorMessage(message)
    } else {
      setSecretNameErrorMessage(null)
    }
    setSecretName(value)
  }
  const handlerSecretValueInputChange = ({target}: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = target

    if (!value) {
      setSecretValueErrorMessage(errorMessageNotEmptyField)
    } else {
      setSecretValueErrorMessage(null)
    }
    setSecretValue(value)
  }
  const handlerConfirmClick = async (e: SyntheticEvent) => {
    e.preventDefault()
    const {data: refToken} = (await addSecureToken({
      projectLocator: id,
      body: secretValue!,
    })) as {data: string}

    if (refToken) {
      onConfirm(secretName, refToken)
    }
  }
  const isFormInvalid =
    secretNameErrorMessage ||
    secretValueErrorMessage ||
    (!secretValue && !isEditMode) ||
    !secretName

  return {
    handlerConfirmClick,
    handlerSecretNameInputChange,
    handlerSecretValueInputChange,
    isFormInvalid,
    secretName,
    secretValue,
    isAddSecureTokenLoading,
    secretNameErrorMessage,
    secretValueErrorMessage,
  }
}

export default usePipelineSecretForm
